<template lang="pug">
page-layout#requests(
	:heading='heading',
	:num-of-slide-outs='1'
	:class='{ "above-side-nav" : requestPageState === "opened" }'
)
	.link-container(slot='link-container')
		.button(@click='requestForm') Add New Action Request
	request-slide-out(
		slot='slideout-1'
		:state='requestPageState'
		:data-state='requestLoadingState'
		:request='activeRequest'
		:asset-key='requestKey'
		asset-name='requests'
		@close='requestPageState = "closed"; activeRequest = null;'
		@edit='editRequest'
		@delete='deleteRequest'
	)
	asset-table(
		slot='content'
		asset-name='actionRequests'
		asset-key='actionRequestsKey'
		search-text='Search for a Request'
		:config='config'
		:get-all='GetRequests'
		:get='GetRequest'
		:search='SearchRequests'
		:download-csv='DownloadRequestsCSV'
		:download-pdf='DownloadRequestsPDF'
		@row-clicked='viewRequest'
	)
</template>

<script>
import AssetTable from '@/components/AssetTable';
import PageLayout from '@/components/PageLayout';
import RequestSlideOut from '@/components/slide-outs/requests';

import {
	GetRequests,
	GetRequest,
	DeleteRequest,
	DownloadRequestsCSV,
	DownloadRequestsPDF,
	SearchRequests
} from '@/lib/API';

import Submit from '@/lib/Submit';
// eslint-disable-next-line no-unused-vars
import { FilterToAPI,	SortToAPI } from '@/lib/utils';
import { editRequest } from '@/lib/generate';
import ActionRequestConfig from '@/lib/assets/actionRequests';

export default {
	name : 'requests',

	data : () => ( {

		heading : {
			title       : 'Engineering Action Requests',
			description : 'Click any row to view the board action requests in full',
		},

		config : {
			columns : ActionRequestConfig.columns,
		},

		requestPageState    : 'closed',
		requestLoadingState : 'loaded',
		activeRequest       : null,
		requestKey          : null,

		GetRequests,
		GetRequest,
		DownloadRequestsCSV,
		DownloadRequestsPDF,
		SearchRequests

	} ),

	created() {
		const { query } = this.$route;
		const { key }   = query;

		if ( key ) {
			this.viewRequest( { actionRequestsKey : key } );
		}
	},

	computed : {

		customMethods() {
			return {
				downloadCSV : DownloadRequestsCSV,
				downloadPDF : DownloadRequestsPDF,
				getAssets   : GetRequests,
				getAsset    : GetRequest,
				search      : SearchRequests,
			};
		}

	},

	methods : {

		requestForm() {
			this.$store.dispatch( 'form', {
				type : 'request',
			} )
				.then( async ( form ) => {

					const stateIndicator = await this.$store.dispatch( 'displayState', {
						message : 'Creating Engineering Action Request Reference...',
						state   : 'loading'
					} );

					Submit.request( form )
						.then( () => form.close() )
						.then( () => stateIndicator.resolve( 'Created Successfully' ) )
						.catch( () => {
							form.close();
							stateIndicator.fail( { header : 'Didn\'t Create Engineering Action Request Reference', message : '' } );
						} );
				} );
		},

		viewRequest( { actionRequestsKey } ) {

			this.activeRequest = null;
			this.requestKey    = null;

			this.requestPageState    = 'opened';
			this.requestLoadingState = 'loading';

			const displayStateOptions = {
				message        : 'Loading Request',
				successMessage : 'Request Loaded',
				failMessage    : 'Request could not be loaded.',
				state          : 'loading',
			};

			this.$store.dispatch( 'loadWithDisplayState', {
				options : displayStateOptions,
				method  : () => GetRequest( actionRequestsKey ),
			} )
				.then( ( request ) => {
					this.activeRequest       = request;
					this.requestKey          = request.actionRequestsKey;
					this.requestLoadingState = 'loaded';
				} )
				.catch( () => {
					this.requestLoadingState = 'failed';
				} );
		},

		closeRequest() {
			this.requestPageState = 'closed';
			this.activeRequest    = null;
		},

		editRequest() {
			this.requestPageState = 'closed';

			const { actionRequestsKey, location } = this.activeRequest;

			if ( location ) this.activeRequest.locationDescription = location.description;
			else this.activeRequest.locationDescription = ' ';

			if ( this.activeRequest.location ) delete this.activeRequest.location;

			const startingData  = editRequest( this.activeRequest );

			this.$store.dispatch( 'form', {
				type : 'request',
				args : [this.activeRequest],
				startingData,
			} ).then( ( form ) => {
				form.close();

				const options = {
					message        : 'Editing request',
					successMessage : 'Successfully edited request',
					failMessage    : 'Failed to edit request',
					state          : 'loading',
				};

				return this.$store.dispatch( 'loadWithDisplayState', {
					options,
					method : () => Submit.editRequest( form, actionRequestsKey ),
				} );
			} ).then( ( actionRequest ) => {
				this.activeRequest = actionRequest;

				this.requestPageState = 'opened';
			} ).catch( ( error ) => {
				throw error;
			} );
		},

		updateAsset( newAsset ) {
			this.activeRequest = newAsset;
		},

		async deleteRequest() {

			const stateIndicator = await this.$store.dispatch( 'displayState', {
				message : 'Deleting Request...',
				state   : 'loading'
			} );

			DeleteRequest( this.activeRequest.actionRequestsKey )
				.then( () => stateIndicator.resolve( 'Deleted Successfully' ) )
				.then( this.requestPageState = 'closed' )
				.catch( ( err ) => {

					console.error( err );

					stateIndicator.fail( { header : 'Didn\'t Delete Request', message : '' } );

				} );

		},

	},

	components : {
		AssetTable,
		PageLayout,
		RequestSlideOut,
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.space-form.request-form {
	@include set-form-color( #B980BA );

	.drop-box-wrapper .background {
		background: lighten( #B980BA, 30% );
	}

	.top-bar {

		.title {
			color: #B980BA;
			width: 40%;
		}
	}

	.check-box-container {
		justify-content: center;
		margin-top: 20px;
	}

	.request-number {
		flex-flow: row nowrap;
		justify-content: flex-start;

		.input-wrapper {
			flex: 1 1 0;

			input {
				text-align: left;
			}
		}
	}

	.date-input {

		&.has-value {

			.select-display {

				p {
					color: $input-color;
				}
			}
		}

		.select-display {

			p {
				color: #B980BA;
			}
		}
	}
}
</style>
